import type { IReadAllParams } from "@/services/RequestParams";

export const screenerParams: Readonly<IReadAllParams> = {
	fields: ["ticker", "adj_close_pct_chg", "days_to_earn"],
};
export const revisionParams: Readonly<IReadAllParams> = {
	fields: ["ticker", "dp", "rs_chg", "rss_chg"],
};
